const base_uri = {
  BASE_URL: "https://config.saveoncrm.com",
  // BASE_URL: "https://elvis2-backend.do.viewyoursite.net",
  // BASE_URL: "http://127.0.0.1:8000",
};

export default base_uri;
